// @flow
import * as React from 'react'
import { EmptyDate, RegularDate } from './elements'

// Types
export type Props = {
  onChange?: Function,
  children?: any,
  past?: boolean,
  today?: boolean,
  empty?: boolean,
  selected?: boolean,
  date: any,
}

/**
 * Day component of a calendar that handles click on it. It
 * calls `onChange` with provided date (only if the date is not
 * in the past and not empty).
 */
class DateItem extends React.Component<Props> {
  handleClick = () => {
    const { onChange, date, past, empty } = this.props
    if (onChange && !past && !empty) {
      onChange(date)
    }
  }

  render() {
    const { empty, past, today, selected, children } = this.props

    if (empty) {
      return <EmptyDate />
    }
    return (
      <RegularDate
        onClick={this.handleClick}
        $past={past}
        $today={today}
        $selected={selected}
      >
        {children}
      </RegularDate>
    )
  }
}

export default DateItem
